import { APICore } from './apiCore';

const api = new APICore();

interface UserData {
    name: string;
    email: string;
    role: string;
}
interface ProfileInfo {
    id?: string;
    name: string;
    email: string;
    mobile_no: string;
    role?: string;
    password?: string;
    avatar?: string | null;
}

export function getUser(userId: number) {
    const baseUrl = `/user/${userId}`;
    return api.get(baseUrl);
}
export function getAllUser(companyId: string) {
    const baseUrl = `/user/all`;
    return api.get(baseUrl);
}

export function createUser(userData: UserData) {
    const baseUrl = '/user/add';
    return api.create(baseUrl, userData);
}

export function updateUser(userId: number, userData: UserData) {
    const baseUrl = `/user/${userId}`;
    return api.update(baseUrl, userData);
}

export function updateProfile(userId: number, formData: FormData) {
    const baseUrl = `/user/${userId}/profile`;
    return api.create(baseUrl, formData);
}


export function deleteUser(userId: number) {
    const baseUrl = `/user/${userId}`;
    return api.delete(baseUrl);
}
